import { createTheme } from '@mui/material/styles';
import { teal, orange, green } from '@mui/material/colors';
import { getEnvironment } from '../config';

const theme = createTheme({
  components: {
    MuiAppBar: {
      defaultProps: {
        // @ts-ignore
        color: getEnvironment(),
      },
    },
  },
  palette: {
    primary: { main: '#385287' },
    secondary: { main: '#973864' },
    // @ts-ignore
    prod: { main: 'primary' },
    qa: { main: orange[500] },
    test: { main: green[500] },
    dev: { main: teal[500] },
  },
});

export const GroupedFieldTheme = createTheme({ ...theme,
  ...{
    components: {
      MuiSelect: {
        styleOverrides: {
          root: {
            textAlign: 'start',
            '&:before': {
            // hide the default underline
              display: 'none',
            },
            '&:after': {
            // hide the underline on hover
              display: 'none',
            },
            marginLeft: 13,
            backgroundColor: 'transparent', // remove background color
          },
        },
      },
    },
  } });

export default theme;
